import { Grid, Card, Text, Group, Badge, useMantineTheme, CardSection } from '@mantine/core'
import { IconStar } from '@tabler/icons-react'
import { StudentDetailsResponse } from '../service/types/interfaces'

interface StudentDetailCardProps {
  detail: StudentDetailsResponse
}

const StudentDetailCard: React.FC<StudentDetailCardProps> = ({ detail }) => {
  const theme = useMantineTheme()

  return (
    <Grid.Col span={12} sm={6}>
      <Card shadow='sm' p='md' radius='md' withBorder>
        <CardSection
          style={{
            backgroundColor: detail.color,
            width: 'auto%',
            padding: '16px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Text weight={500} color={theme.white} align='center'>
            {detail.code}
          </Text>
        </CardSection>
        <Group spacing='xs' mt='xs'>
          <Text weight={500}>{detail.lv4Name}</Text>
          <Badge color='gray'>{detail.lv3Name}</Badge>
          <Badge color='gray'>{detail.lv2Name}</Badge>
          <Badge color='gray'>{detail.lv1Name}</Badge>
          <Group spacing={2}>
            {Array.from({ length: 5 }, (_, i) => (
              <IconStar
                key={i}
                size={16}
                fill={i < Number(detail.score) ? detail.color : 'none'}
                color={i < Number(detail.score) ? detail.color : theme.colors.gray[4]}
              />
            ))}
          </Group>
        </Group>
      </Card>
    </Grid.Col>
  )
}

export default StudentDetailCard
